interface MutationConfig {
  errorMessagePrefix?: string;
  errorMessage?: string;
}

/** Any react-query mutation object passed from usePost / useDelete / usePut hooks. */
export type ParseErrorMessageMutation = {
  error?: unknown;
};

function coerceSnackMessage(value: unknown): string | undefined {
  if (typeof value === 'string' && value.length > 0) {
    return value;
  }
  if (value != null && typeof value !== 'object') {
    return String(value);
  }
  return undefined;
}

function expectedMessageFromResponseData(data: unknown): string | undefined {
  if (data == null || typeof data !== 'object') {
    return undefined;
  }
  const record = data as Record<string, unknown>;
  return coerceSnackMessage(record.message ?? record.error);
}

function responseDataFromMutationError(error: unknown): unknown {
  if (error == null || typeof error !== 'object') {
    return undefined;
  }
  const response = (error as Record<string, unknown>).response;
  if (response == null || typeof response !== 'object') {
    return undefined;
  }
  return (response as Record<string, unknown>).data;
}

function topLevelMessageFromMutationError(error: unknown): string | undefined {
  if (error == null || typeof error !== 'object') {
    return undefined;
  }
  return coerceSnackMessage((error as Record<string, unknown>).message);
}

export function parseErrorMessage(
  config: MutationConfig,
  mutation: ParseErrorMessageMutation
): string {
  const error = mutation?.error;
  const expectedMessage = expectedMessageFromResponseData(
    responseDataFromMutationError(error)
  );

  if (config.errorMessagePrefix && expectedMessage) {
    return `${config.errorMessagePrefix} ${expectedMessage}`;
  }
  if (config.errorMessage) {
    return config.errorMessage;
  }

  return (
    expectedMessage ||
    topLevelMessageFromMutationError(error) ||
    'An unknown error occurred.'
  );
}
